import { render, staticRenderFns } from "./showHobo.vue?vue&type=template&id=2b8aca98"
import script from "./showHobo.vue?vue&type=script&lang=js"
export * from "./showHobo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports